export class NotEnoughColumnsError extends Error {
    expectedColumnsCount;
    actualColumnsCount;
    rowPos;
    constructor(expectedColumnsCount, actualColumnsCount, rowPos) {
        super(`CSV row has ${actualColumnsCount} values in a row #${rowPos}, when expected ${expectedColumnsCount} values`);
        this.expectedColumnsCount = expectedColumnsCount;
        this.actualColumnsCount = actualColumnsCount;
        this.rowPos = rowPos;
    }
}
//# sourceMappingURL=NotEnoughColumnsError.js.map